const styles = {
  alert: {
    width: '100%',
    maxWidth: 400,
    borderRadius: theme => theme.spacing(0.5),

    '& .MuiButton-root': {
      margin: theme => theme.spacing(1.75, 'auto', 0, 0),
    },
  },
  alertWarning: {
    boxShadow: theme => theme.shadows[2],
    position: 'fixed',
    right: theme => theme.spacing(5),
    zIndex: theme => theme.zIndex.drawer,
  },
}

export default styles
